module.exports = __webpack_public_path__ + "assets/img/btn-view-50f085a7.png";